/**
* Logos Marquee JS
* -----------------------------------------------------------------------------
*
* All the JS for the Logos Marquee component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'logos-marquee',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.logos-marquee' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--logos-marquee' )[0], {
          type: 'loop',
          pagination: false,
          arrows: false,
          gap: '80px',
          autoWidth: true,
        } );

        splide.mount( {AutoScroll} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'logos-marquee', COMPONENT );
} )( app );
